__turbopack_context__.v({
  "arrowIcon": "CategoryCarousel-module-scss-module__whIvgG__arrowIcon",
  "caretIcon": "CategoryCarousel-module-scss-module__whIvgG__caretIcon",
  "container": "CategoryCarousel-module-scss-module__whIvgG__container",
  "header": "CategoryCarousel-module-scss-module__whIvgG__header",
  "noImage": "CategoryCarousel-module-scss-module__whIvgG__noImage",
  "placeholderSlide": "CategoryCarousel-module-scss-module__whIvgG__placeholderSlide",
  "screenReaderOnly": "CategoryCarousel-module-scss-module__whIvgG__screenReaderOnly",
  "swipeButt": "CategoryCarousel-module-scss-module__whIvgG__swipeButt",
  "swipeButtNext": "CategoryCarousel-module-scss-module__whIvgG__swipeButtNext",
  "swipeButtPrev": "CategoryCarousel-module-scss-module__whIvgG__swipeButtPrev",
  "swipeRightButtHide": "CategoryCarousel-module-scss-module__whIvgG__swipeRightButtHide",
  "swiper": "CategoryCarousel-module-scss-module__whIvgG__swiper",
  "swiperLeftButtonHide": "CategoryCarousel-module-scss-module__whIvgG__swiperLeftButtonHide",
  "swiperSlide": "CategoryCarousel-module-scss-module__whIvgG__swiperSlide",
  "viewAll": "CategoryCarousel-module-scss-module__whIvgG__viewAll",
  "viewAllBrands": "CategoryCarousel-module-scss-module__whIvgG__viewAllBrands",
  "viewAllButton": "CategoryCarousel-module-scss-module__whIvgG__viewAllButton",
  "viewAllFlex": "CategoryCarousel-module-scss-module__whIvgG__viewAllFlex",
  "viewAllGrid": "CategoryCarousel-module-scss-module__whIvgG__viewAllGrid",
  "viewAllSlide": "CategoryCarousel-module-scss-module__whIvgG__viewAllSlide",
});
